import _isFunction from "lodash/isFunction";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, useEffect, useImperativeHandle } from 'react';
import { useDeepEffect } from '../../hooks';
import { getBase64, checkSize, prepareValue } from './utils';
import inputValidation from '../inputValidation';
import { showError } from '../../Notifications';
export var useFileInput = function useFileInput(_ref) {
  var _ref$value = _ref.value,
      initValue = _ref$value === void 0 ? '' : _ref$value,
      onChange = _ref.onChange,
      onError = _ref.onError,
      onBlur = _ref.onBlur,
      validate = _ref.validate,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$isTouched = _ref.isTouched,
      isTouchedInit = _ref$isTouched === void 0 ? false : _ref$isTouched,
      max = _ref.max,
      numberOfFiles = _ref.numberOfFiles,
      componentRef = _ref.componentRef;
  var inputValue = prepareValue(initValue);

  var _useState = useState(inputValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      dragId = _useState4[0],
      setDragId = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var _useState7 = useState(isTouchedInit !== null && isTouchedInit !== void 0 ? isTouchedInit : false),
      _useState8 = _slicedToArray(_useState7, 2),
      isTouched = _useState8[0],
      setIsTouched = _useState8[1];

  useDeepEffect(function () {
    setValue(inputValue);
  }, [initValue]);
  useEffect(function () {
    setIsTouched(isTouchedInit);
  }, [isTouchedInit]);
  useEffect(function () {
    isTouched && checkForError(value);
  }, [isTouched]);
  useImperativeHandle(componentRef, function () {
    return {
      value: value,
      changeValue: function changeValue(newValue) {
        return handleChange({
          target: {
            value: newValue
          }
        });
      },
      checkForError: checkForError,
      changeError: setError,
      changeIsTouched: setIsTouched
    };
  });

  var handleChange = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
      var files, filesErr, _yield$getBase, _yield$getBase2, base64Files, error, newValue;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              files = event.target.files;
              filesErr = checkSizeAndNumber(files, max);

              if (!filesErr) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", submitError(filesErr));

            case 4:
              _context.next = 6;
              return getBase64(files);

            case 6:
              _yield$getBase = _context.sent;
              _yield$getBase2 = _slicedToArray(_yield$getBase, 2);
              base64Files = _yield$getBase2[0];
              error = _yield$getBase2[1];

              if (!error) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return", showError(error));

            case 12:
              newValue = !multiple ? base64Files[0] : base64Files;
              setValue(function (prev) {
                var items = multiple && prev ? [].concat(_toConsumableArray(prev), _toConsumableArray(newValue)) : newValue;
                setTimeout(function () {
                  checkForError(items);
                  _isFunction(onChange) && onChange(items);
                });
                return items;
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleRemoveItem = function handleRemoveItem(file) {
    setValue(function (prev) {
      var items = prev.filter(function (el) {
        return el.__id !== file.__id;
      });
      setTimeout(function () {
        checkForError(items);
        _isFunction(onChange) && onChange(items);
      });
      return items;
    });
  };

  var handleBlur = function handleBlur() {
    window.removeEventListener('focus', handleBlur);
    !isTouched && setIsTouched(true);
    checkForError(value);
    _isFunction(onBlur) && onBlur();
  };

  var checkSizeAndNumber = function checkSizeAndNumber(files) {
    var err = null;
    if (numberOfFiles && (files === null || files === void 0 ? void 0 : files.length) > numberOfFiles) err = {
      msg: "Maximum number of files is: ".concat(numberOfFiles)
    };
    if (checkSize(files, max)) err = {
      msg: "Maximum file size is: ".concat(max, "MB")
    };
    return err;
  };

  var checkForError = function checkForError(newValue) {
    var newError = null;
    if (_isFunction(validate)) newError = validate(newValue);else if (required) newError = inputValidation('required')(multiple ? newValue.length ? newValue.length : '' : newValue === null || newValue === void 0 ? void 0 : newValue.data);
    submitError(newError);
  };

  var submitError = function submitError(newError) {
    setError(newError);
    _isFunction(onError) && onError(newError);
  };

  var handleDragOver = function handleDragOver(e) {
    e.preventDefault();
  };

  var handleDragStart = function handleDragStart(e) {
    setDragId(e.currentTarget.id);
  };

  var handleDrop = function handleDrop(e) {
    e.preventDefault();
    setValue(function (prev) {
      var dragImageIndex = prev.findIndex(function (image) {
        return image.__id === dragId;
      });
      var dropImageIndex = prev.findIndex(function (image) {
        return image.__id === e.currentTarget.id;
      });
      var reorderedItems = moveItem(dragImageIndex, dropImageIndex);
      setTimeout(function () {
        _isFunction(onChange) && onChange(reorderedItems);
      });
      return reorderedItems;
    });
  };

  var moveItem = function moveItem(fromIndex, toIndex) {
    var items = _toConsumableArray(value);

    var item = items.splice(fromIndex, 1)[0];
    items.splice(toIndex, 0, item);
    return items;
  };

  return {
    // Input props
    value: value,
    onChange: handleChange,
    onBlur: handleBlur,
    onDragOver: handleDragOver,
    onDragStart: handleDragStart,
    onDrop: handleDrop,
    onRemoveItem: handleRemoveItem,
    disabled: disabled,
    multiple: multiple,
    // Form related props
    error: error,
    isTouched: isTouched
  };
};